import slideImageOne from "../../images/v2/home-hero-slider/slider-1.jpg";
import slideImageTwo from "../../images/v2/contact-us/contact-form-image.jpg";
import slideImageThree from "../../images/v2/home-hero-slider/slider-3.jpg";
import slideImageFour from "../../images/v2/home-hero-slider/slide-four.jpeg";
import slideImageFive from "../../images/v2/home-hero-slider/slider-5.jpg";
import slideImageSix from "../../images/v2/home-hero-slider/slider-6.jpg";
import slideImageSeven from "../../images/v2/home-hero-slider/slider-7.jpg";
import slideImage8 from "../../images/v2/home-hero-slider/slider-8.jpg";
import slideImage9 from "../../images/v2/home-hero-slider/slider-9.jpg";
import slideImage10 from "../../images/v2/home-hero-slider/slider-10.jpg";
import slideImage11 from "../../images/v2/home-hero-slider/slider-11.jpg";
import slideImage12 from "../../images/v2/home-hero-slider/slider-12.jpg";
import slideImage13 from "../../images/v2/home-hero-slider/slider-13.jpg";
import slideImage14 from "../../images/v2/home-hero-slider/slider-14.jpg";
import slideImage15 from "../../images/v2/home-hero-slider/slider-15.jpg";
import slideImage16 from "../../images/v2/home-hero-slider/slider-16.jpg";
import slideImage17 from "../../images/v2/home-hero-slider/slider-17.jpg";
import slideImage18 from "../../images/v2/home-hero-slider/slider-18.jpg";
import slideImage19 from "../../images/v2/home-hero-slider/slider-19.jpg";
import slideImage20 from "../../images/v2/home-hero-slider/slider-20.jpg";
import slideImage21 from "../../images/v2/home-hero-slider/slider-21.jpg";
import slideImage22 from "../../images/v2/home-hero-slider/slider-22.jpg";
import slideImage23 from "../../images/v2/home-hero-slider/slider-23.jpg";
import slideImage24 from "../../images/v2/home-hero-slider/slider-24.jpg";

import testimonial1 from "../../images/v2/testimonial1.png";
import testimonial2 from "../../images/v2/testimonial2.png";
import testimonial3 from "../../images/v2/testimonial3.png";
import galleryImg1 from "../../images/v2/gallery-imgs/gallery1.png";
import galleryImg2 from "../../images/v2/gallery-imgs/gallery2.jpg";
import galleryImg5 from "../../images/v2/gallery-imgs/gallery3.jpg";
import galleryImg4 from "../../images/v2/gallery-imgs/gallery4.jpg";
import galleryImg3 from "../../images/v2/gallery-imgs/gallery5.jpg";
import galleryImg6 from "../../images/v2/gallery-imgs/gallery6.png";
import galleryImg7 from "../../images/v2/gallery-imgs/gallery7.jpeg";

export const homeHeroSliderImages = [
  slideImageOne,
  slideImageTwo,
  slideImageThree,
  slideImageFour,
  slideImageFive,
  slideImageSix,
  slideImageSeven,
  slideImage8,
  slideImage9,
  slideImage10,
  slideImage11,
  slideImage12,
  slideImage13,
  slideImage14,
  slideImage15,
  slideImage16,
  slideImage17,
  slideImage18,
  slideImage19,
  slideImage20,
  slideImage21,
  slideImage22,
  slideImage23,
  slideImage24,
];

export const aboutUsInfoCards = [
  {
    heading: "Our Vision",
    paragraph:
      "An Africa where women are equally represented across all career roles and levels in Technology",
  },
  {
    heading: "Our Mission",
    paragraph:
      "To equip African girls and women with access to technology and digital skills training, bridging the gender gap and fostering economic independence.",
  },
  {
    heading: "Our Values",
    paragraph:
      "Team work, Community, Technical growth, Leadership, Visibility, Communication.",
  },
];

export const ourReachData = [
  {
    numbers: "65k",
    description: "program beneficiaries and scholarship recipients.",
    maxW: 599,
  },
  {
    numbers: "7k",
    description:
      "women and girls trained through our Academy and training programs",
    maxW: 483,
  },
  {
    numbers: "40k",
    description: "community members",
    maxW: 498,
  },
  {
    numbers: "5M",
    description:
      "people inspired by the stories of African girls and women in tech",
    maxW: 531,
  },
];

export const aboutUsReachData = [
  {
    numbers: "7,000",
    description:
      "women and girls trained through our Academy and training programs",
  },
  {
    numbers: "40,000",
    description:
      "community members across 20+ African countries and 40+ chapter locations",
  },
  {
    numbers: "65,000",
    description: "program beneficiaries and scholarship recipients.",
  },

  {
    numbers: "5M",
    description: "people Inspired by the Stories of African Girls in Tech.",
  },
];

export const impactStats = [
  {
    id: 1,
    number: "65,000",
    description: "program beneficiaries and scholarship recipients. ",
  },
  {
    id: 2,
    number: "40,000",
    description: "community members",
  },
  {
    id: 3,
    number: "7,000",
    description:
      "women and girls trained through our Academy and training programs",
  },
  {
    id: 4,
    number: "5M",
    description: "people Inspired by the Stories of African Girls in Tech",
  },
];

export const testimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "“Lorem ipsum dolor sit amet consectetur. Et nec sit elementum amet pharetra varius proin eleifend leo. Sagittis aliquet urna suspendisse in ut tincidunt. Magna duis rhoncus ullamcorper massa. Tincidunt eu risus est dapibus. Mi pretium turpis ipsum feugiat et vel eu lacus nec. Adipiscing eget et molesti faucibus arcu metus urna in. Nisi egestas et vitae quam euismodrhoncus enim. Aliquam faucibus mi commodo venenatis diam ante.”",
    name: "Queen Jane",
  },
  {
    img: testimonial2,
    testimonial:
      "“Lorem ipsum dolor sit amet consectetur. Et nec sit elementum amet pharetra varius proin eleifend leo. Sagittis aliquet urna suspendisse in ut tincidunt. Magna duis rhoncus ullamcorper massa. Tincidunt eu risus est dapibus. Mi pretium turpis ipsum feugiat et vel eu lacus nec. Adipiscing eget et molesti faucibus arcu metus urna in. Nisi egestas et vitae quam euismodrhoncus enim. Aliquam faucibus mi commodo venenatis diam ante.”",
    name: "Queen Jane",
  },
  {
    img: testimonial3,
    testimonial:
      "“Lorem ipsum dolor sit amet consectetur. Et nec sit elementum amet pharetra varius proin eleifend leo. Sagittis aliquet urna suspendisse in ut tincidunt. Magna duis rhoncus ullamcorper massa. Tincidunt eu risus est dapibus. Mi pretium turpis ipsum feugiat et vel eu lacus nec. Adipiscing eget et molesti faucibus arcu metus urna in. Nisi egestas et vitae quam euismodrhoncus enim. Aliquam faucibus mi commodo venenatis diam ante.”",
    name: "Queen Jane",
  },
];

export const initiativeTestimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "As an IT Engineer looking to transition to Project Management, this scholarship program came at the time I needed it the most which has contributed in my journey in the project management industry. Through this program, I have learnt a lot about the types of project management methodologies and I am grateful for this opporturnity",
    name: "Seynabou G",
  },
  {
    img: testimonial2,
    testimonial:
      "Went from 0 to 10 really fast in my tech journey, and I just started. I graduated from SCA cloud school, yes, it's okay to address me as a cloud engineer now.",
    name: "Seriki A",
  },
  {
    img: testimonial3,
    testimonial:
      "If I were to rate myself now, I would say I am seven or eight out of ten, and I know that if I keep practising on my own, I will grow even more. My dream is to get my own laptop so I can continue learning and practising everything I was taught. This training has given me confidence. ",
    name: "Damilola A",
  },
];

export const productTestimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "  They say your network is your net worth. SCA is a vibrant community packed with bright and talented women from all walks of life. I have met a few persons who have played key roles in my career journey while attending some events by the community. It's a great place to meet, connect and share ideas with like-minded individuals. There's always something to learn and the willingness to share knowledge is really amazing. The positivity is also palpable.",
    name: "Chioma E",
  },
  {
    img: testimonial2,
    testimonial:
      "Through this program, my confidence has grown significantly by about 80 per cent. I feel bolder and more capable of exploring technology independently. I plan to use these skills to improve my business. I am grateful for this free program, as opportunities like this are rare. It has allowed me to learn valuable skills without the financial burden that often comes with tech training. I hope there will be more opportunities like this in the future, so more people can benefit.",
    name: "Rita O",
  },
  {
    img: testimonial3,
    testimonial:
      "One important lesson I learned is the value of knowledge and confidence, especially for women. We shouldn’t feel limited by societal expectations or the notion that certain skills are for men. Gaining knowledge empowers you, boosts confidence, and allows you to teach others, including your children, so they are not left behind. I have always loved technology, but time constraints and my shy nature limited my exploration. Now, I am motivated to continue learning, grow my tech skills, and leverage them both professionally and personally.",
    name: "Rachel O",
  },
];

export const skillTestimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "As an IT Engineer looking to transition to Project Management, this scholarship program came at the time I needed it the most which has contributed in my journey in the project management industry. Through this program, I have learnt a lot about the types of project management methodologies and I am grateful for this opporturnity",
    name: "Seynabou G",
  },
  {
    img: testimonial2,
    testimonial:
      "Preparing for the GitHub Foundations Certification exam was both an exciting and rewarding journey. I dedicated time to learning core concepts around Git, GitHub workflows, collaboration, version control, and repository management. The materials provided and the resources I found online helped build my confidence gradually. The exam itself was well-structured and tested both theoretical understanding and practical application.",
    name: "Oyinkansola S",
  },
  {
    img: testimonial3,
    testimonial:
      "It has been an exciting journey becoming more grounded in various aspects of IT support through the SCA x GWG scholarship opportunity. Despite my experience in the tech space, this course has significantly broadened my knowledge in several areas crucial to my career development as a technical professional.",
    name: "Anuoluwapo O",
  },
];

export const engTestimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "As an IT Engineer looking to transition to Project Management, this scholarship program came at the time I needed it the most which has contributed in my journey in the project management industry. Through this program, I have learnt a lot about the types of project management methodologies and I am grateful for this opporturnity",
    name: "Seynabou G",
  },
  {
    img: testimonial2,
    testimonial:
      "The program provided not only detailed lectures but also hands-on practice through simulated labs.Additionally, the She Code Africa community has been incredibly supportive and beneficial to my growth. Thanks to this experience, I am now more confident in exploring higher-level roles in the technical support field.",
    name: "Anuoluwapo O",
  },
  {
    img: testimonial3,
    testimonial:
      "Went from 0 to 10 really fast in my tech journey, and I just started. I graduated from SCA cloud school, yes, it's okay to address me as a cloud engineer now.",
    name: "Seriki A",
  },
];

export const sponsorTestimonialCards = [
  {
    img: testimonial1,
    testimonial:
      "Went home with a brand new laptop! This experience has reassured me that truly there is light at the end of the tunnel. However, you won’t see the light unless you keep moving forward. So, keep pushing, and soon enough, that light will shine brightly on your path as the smile on my ladies faces below.",
    name: "Oluwatitomi A",
  },
  {
    img: testimonial2,
    testimonial:
      "There are very very very few communities that can do what She Code Africa does. Access to mentorship, Laptop benefits, data stipends, Job opportunities, to mention a few. She Code Africa is also a safe space for women in tech. The community is filled with amazing ladies who are always willing to help and provide guidance",
    name: "Damilola E",
  },
  {
    img: testimonial3,
    testimonial:
      "I am a teacher, and I am also working on completing my BSc. Before this Digital Literacy program, my digital knowledge was very limited. The only thing I could do was type a little, although not as fast as a typist. If I were to rate myself back then, I would say I was just one or two over ten. If I were to rate myself now, I would say I am seven or eight out of ten, and I know that if I keep practising on my own, I will grow even more. My dream is to get my own laptop so I can continue learning and practising everything I was taught. This training has given me confidence. ",
    name: "Damilola A",
  },
];

export const ourGallery1 = [galleryImg1, galleryImg2];

export const ourGallery2 = [galleryImg3, galleryImg4, galleryImg5];

export const ourGallery3 = [galleryImg6, galleryImg7];

export const mailingList = [
  {
    title: "For partnerships",
    email: "partnerships@shecodeafrica.org",
  },
  {
    title: "For media",
    email: "media@shecodeafrica.org",
  },
  {
    title: "For programs",
    email: "programs@shecodeafrica.org",
  },
];

export const milestoneData = [
  {
    year: 2016,
    yearRange: "",
    title: "The beginning",
    range: false,
    subText:
      "September 13th : She Code Africa was founded with a vision to celebrate and support African women in tech.",
  },
  {
    year: "",
    range: true,
    yearRange: "2017-2018",
    title: "Community Roots",
    subText:
      "Grew organically through digital storytelling and visibility campaigns. Spotlighted dozens of women across Africa, building the foundation for a broader movement.",
  },
  {
    year: 2019,
    yearRange: "",
    range: false,
    title: "Community arm Launched",
    subText:
      "Launched our community platform and began organizing local meetups, learning circles, and mentorship sessions.",
  },
  {
    year: 2020,
    yearRange: "",
    range: false,
    title: "Programs and Scale",
    subText:
      "Transitioned into a full-fledged organisation and launched our first structured technical cohort programs for beginners and mid-level women in tech. Expanded into virtual formats due to the pandemic, reaching more countries across Africa.",
  },
  {
    year: "",
    yearRange: "2021-2022",
    range: true,
    title: "Strategic Partnerships, Deeper Impact & Stronger Reach",
    subText:
      "Secured partnerships with major tech companies and ecosystem leaders, grew active local chapters in Nigeria, Ghana, Rwanda, and Kenya and hosted our first headline Summit, bringing together hundreds of women in tech from across Africa.",
  },
  {
    year: 2023,
    yearRange: "",
    range: false,
    title: "The Road to 100,000",
    subText:
      "She Code Africa set out with a bold goal to equip 100,000 African women by 2030, with clear pathways in learning, mentorship, and careers. We also launched the STEM-a-Girl initiative to spark early interest in tech among African girls.",
  },
  {
    year: 2024,
    yearRange: "",
    range: false,
    title: "Global Recognition & New Era",
    subText:
      "Selected as a grantee of the HP Digital Equity Accelerator 2025 alongside multiple local and international awards.",
  },
  {
    year: 2025,
    yearRange: "",
    range: false,
    title: "Sustaining the Vision ",
    subText:
      "With stronger partnerships and bolder goals, we are moving closer to a future where no African girl or woman is left out of tech. Every step we take now is a step toward that shared future.",
  },
];

export const milestoneImgDataOne = [
  {
    title: "The Beginning",
    image: "bg-[url('./images/v2/milestone/milestone.jpg')]",
    yearRange: "2016",
  },
  {
    title: "Training Program",
    image: "bg-[url('./images/v2/milestone/milestone2.jpg')]",
    yearRange: "2017",
  },
  {
    title: "Chapter Expansions Across Africa",
    image: "bg-[url('./images/v2/milestone/milestone3.jpg')]",
    yearRange: "2018 - 2020",
  },
  {
    title: "Chapters Meetup (OAU)",
    image: "bg-[url('./images/v2/milestone/milestone4.png')]",
    yearRange: "2021",
  },
];

export const milestoneImgDataTwo = [
  {
    title: "She Code Africa Laptop Scholarship",
    image: "bg-[url('./images/v2/milestone/milestone5.jpg')]",
    yearRange: "2022",
  },
  {
    title: "She Code Africa Summit",
    image: "bg-[url('./images/v2/milestone/milestone6.jpg')]",
    yearRange: "2023",
  },
  {
    title: "Stem-A-Girl Initiative",
    image: "bg-[url('./images/v2/milestone/milestone7.jpg')]",
    yearRange: "2024",
  },
  {
    title: "HP 2025 Digital Equity Accelerator",
    image: "bg-[url('./images/v2/milestone/milestone8.jpg')]",
    yearRange: "2025",
  },
];

export const challengeData = [
  {
    number: "5k",
    description:
      "girls and women impacted through our academy programs, community events, and scholarship initiatives.",
  },
  {
    number: "2674",
    description: "women and girls trained through our training programs.",
  },
  {
    number: "760k",
    description:
      "women and girls reached through our community activities and events.",
  },
  {
    number: "4.5M",
    description:
      "women and girls reached through our community activities and events.",
  },
];
